import React from 'react'
import { GalleryStyles as styles } from "./chat.tailwind";
import ImagePreview from './ImagePreview';
import VideoPreview from './VideoPreview';
import UnknownPreview from './UnknownPreview';
import FileUploadProgress from './FileUploadProgress';
import delete_white from "../../../../../../assets/svgs/delete_white.svg"
import { Alert } from '@mui/material';
import { getFileType } from './livechat.data';

const UploadFilePreview = ({ file, uploadProgress, index, isRejected = false, removeFile, reason, uploadedFiles, removeRejectedFile }) => {
    const fileType = getFileType(file?.type);
    
    return (
        <div className={`${styles.previewFileContainer}`}>
            {/* Rejection Message */}
            {isRejected && (
                <Alert variant='filled' severity="error"
                    sx={{
                        position: 'absolute',
                        display: 'flex',
                        alignItems: 'center',
                        width: '100%',
                        backdropFilter: 'blur(3px)',
                        backgroundColor: '#d32f2f85',
                        bottom: 0,
                        left: 0,
                        zIndex: 2,
                        padding: '0px 12px',
                        fontSize: '12px',
                        textAlign: 'left',
                        '@media (max-width:499px)': {
                            padding: '0px 8px',
                        }
                    }}
                >
                    {reason}
                </Alert>
            )}

            {/* Remove Button */}
            <button
                className={styles.removeButton}
                disabled={uploadProgress?.isUploading}
                onClick={() => { isRejected ? removeRejectedFile(index) : removeFile(index) }}
            >
                <img src={delete_white} />
            </button>

            {/* Preview File */}
            {fileType === 'image' && <ImagePreview url = {URL.createObjectURL(file)} isRejected={isRejected} uploadProgress={uploadProgress} />}

            {fileType === 'video' && <VideoPreview url = {URL.createObjectURL(file)} isRejected={isRejected} uploadProgress={uploadProgress} />}

            {fileType === 'unknown' && <UnknownPreview />}

            {/* <div className={styles.previewFileNew}>
                <div className={styles.iconContainer}>
                    <Upload size={14} />
                </div>
                <div className={styles.mainContainer}>
                    detail with delete button
                    <div className={styles.upperContainer}>
                        <p>{file?.name || "fileName"}</p>
                        Remove Button
                        <button
                            className={styles.removeButton}
                            onClick={() => removeFile(index)}
                        >
                            <img src={delete_black} />
                        </button>
                    </div>
                    progress Bar
                    <div>
                        Progress Bar
                    </div>
                    meta info
                    <div className= {styles.bottomContainer}>
                        <p>{(Math.floor(file?.size / 1024))} mb</p>
                        <p>num</p>
                    </div>
                </div>
            </div> */}


            {/* show the progress Bar for respective files */}
            {(!isRejected && uploadProgress?.isUploading) && (
                <FileUploadProgress
                    file={file}
                    currentFile={uploadProgress.currentFile}
                    progress={uploadProgress.progress}
                    uploadedFiles={uploadedFiles}
                />
            )}
        </div>
    );
}

export default UploadFilePreview